export default {
  title: 'Configurações',
  icon: 'SettingsIcon',
  // resource: 'Auth', // 'ChartOfAccount'
  // action: 'read', // 'Read'
  // iconPack: 'bootstrap',
  children: [
    {
      title: 'Fiscal',
      icon: 'FileTextIcon',
      resource: 'Auth', // 'ChartOfAccount'
      action: 'read', // 'Read'
      children: [
        {
          title: 'Cfop',
          route: 'cfop-list',
          resource: 'Cfop',
          action: 'Read',
        },
        {
          title: 'Classificação Fiscal',
          route: 'tax-classification-list',
          resource: 'TaxClassification',
          action: 'Read',
        },
        {
          title: 'Exceções Fiscais',
          route: 'tax-configuration-group-list',
          resource: 'TaxConfigurationGroup',
          action: 'Read',
        },
        {
          title: 'Parâmetros Fiscais',
          route: 'fiscal-tax-parameter-list',
          resource: 'FiscalTaxParameter',
          action: 'Read',
        },
        {
          title: 'Inconsistências Fiscais',
          route: 'tax-classification-list-inconsistencies',
          resource: 'TaxClassification',
          action: 'Read',
        },
      ],
    },
    {
      title: 'Financeiro',
      icon: 'DollarSignIcon',
      children: [
        {
          title: 'Contas Gerenciais',
          route: 'management-account-list',
          resource: 'ManagementAccount',
          action: 'Read',
        },
        {
          title: 'Forma de Pagamento',
          route: 'payment-type-list',
          resource: 'PaymentMethod',
          action: 'Read',
        },
        {
          title: 'Cartão de Crédito/Débito',
          route: 'card-list',
          resource: 'SettingsFinancialCards', // 'Card'
          action: 'Read', // 'Read'
        },
        {
          title: 'Custo de Adquirente',
          route: 'acquirer-cost-config-list',
          resource: 'SettingsFinancialAcquirerCostConfigs',
          action: 'Read',
        },
        {
          title: 'Política de Parcelamento',
          route: 'installment-policy-list',
          resource: 'SettingsFinancialInstallmentPolicies',
          action: 'Read',
        },
      ],
    },
    {
      title: 'Vendas',
      icon: 'ShoppingCartIcon',
      children: [
        {
          title: 'Recompensas',
          route: 'reward-configuration',
          resource: 'Auth',
          action: 'read',
        },
        {
          title: 'Contrato Comodato',
          route: 'lending-contract-configuration',
          resource: 'LendingContract',
          action: 'Update',
        },
      ],
    },
    {
      title: 'Calendário',
      icon: 'CalendarIcon',
      route: 'calendar-list',
      resource: 'SeasonalCalendar',
      action: 'Read',
    },
    {
      title: 'Parâmetros do Sistema',
      icon: 'SlashIcon',
      route: 'parameter-maintenance',
      resource: 'Parameter',
      action: 'Update',
    },
  ],
}
